import React, { Component } from 'react';
import './HideBtn.css';
import { BrowserView, MobileView, isBrowser, isMobile, isFirefox, isTablet, isMobileOnly, isAndroid, isIOS, browserName } from 'react-device-detect';


class HideBtn extends Component {

    constructor(props) {
        super(props);
        console.log("props HideBtn", props)
        this.state = {
            eyei: true,
        }

        this.registerationView = props.registerationView ? props.registerationView : false;
        this.registerationMobileView = props.registerationMobileView ? props.registerationMobileView : false;

    }

    handleI = () => {
        this.setState({ eyei: !this.state.eyei })
        this.props.changei(!this.state.eyei)
    }

    render() {
        return (
            <div>
                {!this.registerationView && !this.registerationMobileView ?
                    <div style={{ flex: 1 }}>
                        <label className="eSwitchu" style={{ flex: 1, }}>
                            <input type="checkbox" onChange={this.handleI} />
                            <span className="slideru round"></span>
                        </label>
                    </div> : null
                }
                {this.registerationView ?
                    <div style={{ flex: 1 }}>
                        <label className={isFirefox ? "eSwitchrpf" : "eSwitchrp"} style={{ flex: 1, }}>
                            <input type="checkbox" onChange={this.handleI} />
                            <span className="sliderrp round"></span>
                        </label>
                    </div> : null
                }
                {this.registerationMobileView ?
                    <div style={{ flex: 1 }}>
                        <label className="eSwitchrpm" style={{ flex: 1, }}>
                            <input type="checkbox" onChange={this.handleI} />
                            <span className="sliderrpm round"></span>
                        </label>
                    </div> : null
                }
            </div>
        );
    }
}

export default HideBtn;


// WEBPACK FOOTER //
// ./src/assets/components/button/HideBtn.js